module.exports = __webpack_public_path__ + "media/images/defaultguidance-d629f232.png";